import React, { memo, SVGProps } from 'react'

export const ArrowLeft = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.95647 12.2775C1.99295 12.3648 2.04575 12.4435 2.11103 12.5098L10.0589 20.4576C10.199 20.5978 10.3833 20.6688 10.5677 20.6688C10.752 20.6688 10.9363 20.5987 11.0765 20.4576C11.3577 20.1763 11.3577 19.7203 11.0765 19.4391L4.35743 12.72H21.3782C21.7757 12.72 22.0982 12.3975 22.0982 12C22.0982 11.6026 21.7757 11.28 21.3782 11.28H4.35839L11.0774 4.56097C11.3587 4.27969 11.3587 3.82369 11.0774 3.54241C10.7961 3.26113 10.3401 3.26113 10.0589 3.54241L2.11103 11.4912C2.04479 11.5575 1.99295 11.6362 1.95647 11.7235C1.91999 11.8109 1.90079 11.905 1.90079 12.001C1.90079 12.097 1.91999 12.1901 1.95647 12.2775Z"
      fill="currentColor"
    />
  </svg>
))
